import { useContext } from 'react';

import { CommentsMainContext } from '@widgets/Comments/model/context';

export const useCommentsMainContext = () => {
    const context = useContext(CommentsMainContext);

    if (!context) {
        throw new Error('useCommentsMainContext must be used within CommentsMainContext.Provider');
    }

    return context;
};
